var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [(_vm.isUserBuyerGroup(_vm.loggedUserData) || _vm.isConsultantNotHolding(_vm.loggedUserData)) && _vm.order != null && _vm.idUser == _vm.idOrderUser ? _c("userOrderSummary", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e(), _vm.idUser != _vm.idOrderUser && _vm.isDataLoading == false ? _c("Error", {
    attrs: {
      error: _vm.error
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };